
import DivSpan from '@/components/DivSpan';
import fileUpload from '@/components/file-upload';
import Popup from 'vux/src/components/popup/index.vue'


export default {
name: "supplier-view-list",
components: { DivSpan,fileUpload,Popup},
data() {
return {
dataId:'',
plan: {
"creator":{},
"attachment":{},
'requireGoodsOrderDts':[]
},
requireGoodsOrderDt:{},
dtos:[],
tableConf: {
'tr1':[],
'tr2':[]
},
isVisible: false,
requireGoodsOrderDtsData: [],
operationList:[{label:'发布',key:'commit'},{label:'保存',key:'save'}],
view: false,
index: '',
showContent: false,
showContent2: false,
operationBol: false,
}
},
methods: {
operationShow(){
this.operationBol = true;
},
operation(key,item){
if(key !== 'cancel' && item){
if(item.key === 'commit'){
let flag = this.requiredValid();
if (!flag) {
return;
}
this.plan.requireGoodsOrderDts.forEach(x => {
x.status = 'confirm';
x.requireGoodsOrderDtRows.forEach(y => {
y.status = 'confirm';
});
});
this.$loadingShow()
this.$put('api/requireGoodsOrder',this.plan).then(data=>{
this.$loadingHide()
this.$vux.toast.text('发布成功！')
this.$router.go(-1);
}).catch(err=>{
this.$loadingHide()
})

}else if(item.key === 'save'){
this.$loadingShow()
this.$put('api/requireGoodsOrder',this.plan).then(data=>{
this.$loadingHide()
this.$vux.toast.text('保存成功！')
this.$router.go(-1);
}).catch(err=>{
this.$loadingHide()
})
}
}
},
requiredValid() {
for (let i = 0; i < this.plan.requireGoodsOrderDts.length; i++) {
let flag = false;
this.plan.requireGoodsOrderDts[i].requireGoodsOrderDtRows.forEach(row => {
if (row.planType == 'confirm' && row.planCount) {
flag = true;
}
});
if (!flag) {
this.$vux.toast.text( '物料:' + this.plan.requireGoodsOrderDts[i].matName + '未填写要货数量');
return false;
}
}
return true;
},
goBack(){

let orderDtoList=[];
for(let i=0;i<this.dtos.length;i++){
orderDtoList.push(...this.dtos[i].rows)
let sum = 0;
this.dtos[i].rows.forEach(y => {
if (y.planCount) {
sum = sum + parseInt(y.planCount);
}
});

if (sum > this.plan.requireGoodsOrderDts[this.index].surplusCountToPlan) {
this.$vux.confirm.show({
title:'操作提示',
content:'总计划数量已大于订单可计划数量，确认继续吗？',
onConfirm : () => {
this.isVisible=false;
},
})
return;
}
if(i==this.dtos.length-1){
this.isVisible=false;
}
}
this.plan.requireGoodsOrderDts[this.index].requireGoodsOrderDtRows=orderDtoList;

},

itemView(i) {
this.isVisible = !this.isVisible;
this.index = i;
this.requireGoodsOrderDt = this.plan.requireGoodsOrderDts[i];
this.dtos= [];
let z = 0;
this.tableConf.tr1.forEach((x,k)=> {
let dto  = {
'rows': []
};
dto.planType = x.planType;
for (let y = 0; y < x.size; y++){
dto.rows.push(this.plan.requireGoodsOrderDts[i].requireGoodsOrderDtRows[z]);
z++;
}
this.dtos.push(dto);
});
},
changeShow(data,i) {
if (data[i].showContent) {
this.$set(data[i], 'showContent', false);
return;
}
this.$set(data[i], 'showContent', true);
},

getBaseDto() {
this.$loadingShow();
this.$get('api/requireGoodsOrder/' + this.dataId).then((data) => {
if (data) {
this.plan = data;
this.setTableConf(data)
}
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
},

goGeneral() {
if(this.$store.state.device === 'wap'){
this.$router.go(-1);
}else{
document.location = "http://action:10002/?";
}
},
setTableConf(data){
let conf = {
tr1:[],
tr2:[[],[]]
};
let confTitle= {
planType:null,
size:0
};
let timeType = null;
let rows = data.requireGoodsOrderDts[0].requireGoodsOrderDtRows;
for (let i = 0; i < rows.length; i++){
let requireGoodsOrderDtRow = {};
requireGoodsOrderDtRow.askDate = rows[i].askDate;
requireGoodsOrderDtRow.requireGoodsDateFrom = rows[i].requireGoodsDateFrom;
requireGoodsOrderDtRow.requireGoodsDateTo = rows[i].requireGoodsDateTo;
if(rows[i].planType=='confirm'){
conf.tr2[0].push(rows[i]);
}else{
conf.tr2[1].push(rows[i]);
}

if (!timeType) {
timeType = rows[i].timeType
} else {
if (rows[i].timeType != timeType){
timeType = rows[i].timeType;
conf.tr1.push(confTitle);
confTitle= {
planType:null,
size:0
};
}
if ( i == rows.length - 1){
conf.tr1.push(confTitle);
}
}
confTitle.planType = rows[i].planType;
confTitle.size++;
}
conf.tr1.forEach(x => {
if (x.planType == "confirm"){
x.planType = '确定计划';
}
if (x.planType == "plan"){
x.planType = '参考计划';
}
});
this.$set(this.tableConf.tr2,'tr2',conf.tr2)
this.tableConf = conf;
}

},
mounted() {
this.dataId=this.$route.params.id;
this.getBaseDto()
},


}



// WEBPACK FOOTER //
// ./src/page/cargo-plan/cargo-edit.vue